import { defineComponent as _defineComponent } from 'vue'
import ApexSensorChartDetails from './ApexSensorChartDetails.vue'
import TriggerDetailsPanel from './TriggerDetailsPanel.vue'
import { SensorSummary } from '@/models/sensors-dto'
import moment from 'moment'
import _ from 'lodash'
import { computed, ref, toRef } from 'vue'
import { getAdminPortalConfig } from '@/api/config'
import { useQuery } from '@tanstack/vue-query'
import { useGetters } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationDetailsSensorsTab',
  props: {
    sensorsList: null
  },
  setup(__props: any) {

const props = __props as {
  sensorsList: SensorSummary[]
}



const sensors = toRef(props, 'sensorsList');

const sensorsWithTriggers = sensors.value.filter(s => s.triggers.length > 0).map(s => s.id);
const showJobFlags = ref<string[]>(sensorsWithTriggers)
const showAggregate = ref<string[]>([])

const additionalSensorDetails = computed(() => {
  return _.keyBy(sensors.value.map(s => ({
    id: s.id,
    hasTriggers: s.triggers.length > 0,
    hasGroup: s.triggers.some(t => t.sensorIds.length > 0),
    adminPortalLink: `${config.value?.data.url}/organization/${s.owner}/sensors/${s.id}`,
    infoMessage: (s.triggers.length === 0) ? "This device has no triggers" :
                 (s.triggers.length > 1) ? "This device has multiple triggers" :
                 (s.triggers[0].sensorIds.length > 1) ? "This device is part of a group" :
                 null,
  })), s => s.id)
})

const toggleShowJobFlags = (sensorId: string) => {
  if (isShowJobFlagsActive(sensorId)) {
    showJobFlags.value = showJobFlags.value.filter(s => s !== sensorId)
  } else {
    showJobFlags.value = [...showJobFlags.value, sensorId];
  }
}

const isShowJobFlagsActive = (sensorId: string) => {
  return showJobFlags.value?.indexOf(sensorId) !== -1;
}

const toggleShowAggregate = (sensorId: string) => {
  if (isShowAggregateActive(sensorId)) {
    showAggregate.value = showAggregate.value.filter(s => s !== sensorId)
  } else {
    showAggregate.value = [...showAggregate.value, sensorId];
  }
}

const isShowAggregateActive = (sensorId: string) => {
  return showAggregate.value?.indexOf(sensorId) !== -1;
}

const { data: config } = useQuery({
  queryKey: ['config'],
  queryFn: getAdminPortalConfig,
  cacheTime: Infinity,
  staleTime: moment.duration(1, 'days').asMilliseconds(),
})

const { hasAccountOrganizationAccess } = useGetters(
  'permissions',
  ['hasAccountOrganizationAccess']
)

const canConfigureSensors = computed(() => {
  return hasAccountOrganizationAccess.value
})

const configureSensor = (sensor: SensorSummary) => {
  const link = additionalSensorDetails.value[sensor.id].adminPortalLink;
  window.open(link, '_blank');
}


return { __sfc: true,props, sensors, sensorsWithTriggers, showJobFlags, showAggregate, additionalSensorDetails, toggleShowJobFlags, isShowJobFlagsActive, toggleShowAggregate, isShowAggregateActive, config, hasAccountOrganizationAccess, canConfigureSensors, configureSensor, ApexSensorChartDetails, TriggerDetailsPanel }
}

})